import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextField } from '@mui/material';
import _ from 'lodash';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import toast from 'react-hot-toast';

type TagProps = {
  values: string[];
  onChange: (values: string[]) => void;
};

export const Tags = ({ values, onChange }: TagProps) => {
  const [tag, setTag] = useState('');

  const handleKeyDown = (keyCode?: string) => {
    if (keyCode === 'Enter') {
      if (values.includes(tag)) {
        toast.error('Provided tag already exist');
        return;
      }
      onChange([...values, tag]);
      setTag('');
    }
  };

  const onTagDelete = (value: string) => {
    onChange(values.filter((x) => x !== value));
  };

  return (
    <div className="flex flex-col gap-4">
      {!_.isEmpty(values) ? (
        <div className="flex flex-wrap items-center gap-2">
          {values.map((value) => (
            <div
              key={value}
              className="flex justify-center items-center gap-2 p-2 pl-4 rounded-lg bg-[#F8F8F8]"
            >
              <span className="text-sm font-medium">{value}</span>
              <FontAwesomeIcon
                icon={faXmark}
                className="cursor-pointer"
                onClick={() => onTagDelete(value)}
              />
            </div>
          ))}
        </div>
      ) : null}
      <div className="flex flex-col max-w-[280px]">
        <TextField
          value={tag}
          onChange={(ev) => setTag(ev.target.value)}
          onKeyDown={(event) => handleKeyDown(event?.key)}
        />
        <span className="px-3 py-1 text-sm font-medium text-[#646464]">
          Press Enter after typing to add new one
        </span>
      </div>
    </div>
  );
};
